import React, { Component } from 'react'

import { Badge } from 'react-bootstrap';

class RenderClientesStatus extends Component {

  renderStatus = (item, isNewUser) => {
    const { status } = item;

    let text = 'Activando';
    let variant = 'info';

    switch (status) {
      case 1:
        text = 'Activo';
        variant = 'success';
        break;

      case -1:
        text = 'Suspendido';
        variant = 'danger';
        break;

      case 2:
        if (isNewUser) {
          text = 'Nuevo';
          variant = 'info';
        } else {
          text = 'Activo';
          variant = 'success';
        }
        break;

      case -2:
        text = 'Falta de pago';
        variant = 'danger';
        break;

      default:
        break;
    }

    return <Badge variant={ variant }>{ text }</Badge>
  }

  render() {
    const { item = {}, isNewUser = false } = this.props;

    return (
      <>
        { this.renderStatus(item, isNewUser) }
      </>
    )
  }
}

export default RenderClientesStatus;